import { Label } from './common/label'
import { useForm } from './form'

export const FormSimplePassword = ({ name, label, required, hidden, readonly, placeholder, defaultValue, autoFocus }) => {
  const { register } = useForm(name, { required, defaultValue, shouldDirty: true })

  return (
    <Label name={name} label={label} required={required} hidden={hidden}>
      <input
        type="password"
        className={`form-control ${readonly && 'bg-secondary-subtle'}`}
        {...register()}
        readOnly={readonly}
        placeholder={placeholder || label || name}
        autoFocus={autoFocus}
      />
    </Label>
  )
}
